<template>
	<div v-if="!isBeforeConfirm">
			<div class="mdc-card  mgb-24 pda-24">
					<div class="position-relative">
									<!-- <div class="dashed-line-vertical" style="left:30%"></div> -->
									<div class="percentage-wrapper">
										<div class="d-flex justify-content-between align-items-center">
											<div class="t-color-lecturePurple t-helper font-r">{{$t('79')}}</div>
											<div class="d-flex align-items-baseline">
												<div class="percent-number t-color-lecturePurple t-subtitle1 l-spacing6 font-b mgr-4 ">
														{{`${score}`}}</div>
												<div class="t-color-lecturePurple t-helper font-r">{{$t('91', {str: ''})}}</div>
											</div>
										</div>
										<div class="h-2 position-relative total-percentage mgt-1 mgb-20 bg-iconinactiveText">
											<div class="real-percentage bg-lecturePurple h-6 " :style="`width:${score}%;`">
											</div>
										</div>
									</div>
									<div class="percentage-wrapper">
													<div class="d-flex justify-content-between align-items-center">
																	<div class="t-color-iconInactive t-helper font-r"> {{$t('80')}}</div>
																	<div class="d-flex align-items-baseline">
																					<div
																									class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
																									{{`${averageScore}`}}
																					</div>
																					<div class="t-helper t-color-iconInactive font-r">{{$t('91', {str: ''})}}</div>
																	</div>
													</div>
													<div class="h-2 position-relative total-percentage mgt-5 bg-iconinactiveText">
																	<div class="real-percentage bg-iconInactive h-6"  :style="`width:${averageScore}%;`">
																	</div>
													</div>
									</div>
					</div>
	</div>
	<div class="d-grid-3-24 mgb-24">
					<div class="mdc-card pda-24">
									<div class="t-center t-headline9 font-rb t-line-h-29">{{countTotal}}</div>
									<div class="t-body3 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-6">{{$t('81')}}</div>
					</div>
					<div class="mdc-card pda-24">
									<div class="t-center t-headline9 font-rb t-line-h-29">{{countCorrect}}</div>
									<div class="t-body3 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-6">{{$t('82')}}</div>
					</div>
					<div class="mdc-card pda-24">
									<div class="t-center t-headline9 font-rb t-line-h-29">{{countIncorrect}}</div>
									<div class="t-body3 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-6">{{$t('83')}}</div>
					</div>
	</div>
	<div class="mdc-card pdt-10 pdb-10 pdl-24 pdr-24 ">
					<div class="d-flex align-items-center justify-content-between ">
									<div class="t-subtitle3 font-r  t-line-h-22">{{$t('84')}}
									</div>
									<button class="mdc-icon-button content-trigger mgr--12" @click="toggleQuestionViewStatus"  tabindex="0">
										<i class="material-icons t-headline12 t-color-bodyGrayA">{{questionViewStatus ? 'expand_less' : 'expand_more'}}</i></button>
					</div>
					<div class="detail-content w-full mgt-12" v-show="questionViewStatus">
									<div class="d-flex flex-wrap result">
													<div v-for="(question, index) in questions" :key="index" 
													:class="question.correct === true ? 'correct' : 'incorrect'"
													class="t-subtitle2 t-line-h-24 t-center t-color-disableBtn min-w-32 pdl-15 mgr-24 mgb-21 position-relative question">
																	{{index+1}}
													</div>
									</div>
					</div>
	</div>
	<div class="d-flex">
		<div class="mgt-50" v-for="(action, index) in examActions" :key="index">
			<template v-if="setButtonActionName(action)">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8"
					:disabled="setButtonDisabled(action)" @click="examAction(action)" @keypress="examAction(action)" v-if="action.action === 'open_confirm'" tabindex="0">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
				</button>
				<button class="mdc-button  mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText  b-radius4"  :disabled="setButtonDisabled(action)" @click="examAction(action)" @keypress="examAction(action)" tabindex="0" v-else>
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
				</button>
			</template>
		</div>
	</div>
	<div class="mgb-70"></div>
	</div>
<div class="pda-default d-flex flex-column justify-content-between align-items-center" v-else>
		<div class="mgt-50 mgb-50">
						<img src="@/images/exam_before_confirm.png" alt="">
		</div>
		<div class="t-subtitle4">
						{{$t('28')}}    
						<!-- 성적 조회 기간이 아닙니다 -->
		</div>
</div>
</template>

<script>
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'

export default {
	data() {
		return {
			paperName : '',
			examineeId: null,
			countTotal: 0,
			countCorrect: 0,
			countIncorrect: 0,
			scoreMy: 0,
			questions: null,

			questionViewStatus: true,

			examActions: [],
			paperId: 0,

			scoreData: null,
			averageScore: 0,
			standard: 0,
			score: 0,

			applicationEarnPoint: 0,
			solveAllEarnPoint: 0,
			getTotalPoint: 0,
		}
	},

	components: {
		
	},

	mixins: [examMixin],
	
	computed: {
		isBeforeConfirm() {            
			let actionIndex = _.findIndex(this.examActions,(action) => { return action.action === 'before_confirm'})
			return actionIndex >= 0
		}
	},

	mounted() {
		let responseData = null
		this.examineeId = this.$route.params.examineeId
		let params = {
			examineeId: this.examineeId
		}

		examApi.submitedList(params).then((response) => {
			responseData = response.data.data
			// console.log('responseData', responseData)
			
			
			let lastSubmitData = _.head(responseData)
			// console.log('lastSubmitData', lastSubmitData)

			this.paperId = lastSubmitData.id

			params = {
				examineeId: this.examineeId,
				paperId: this.paperId
			}


			examApi.result(params).then((response) => {
				responseData = response.data.data
				//console.log('result responseData', responseData)
				this.paperName = responseData.name
				this.countTotal = responseData.count.total
				this.countCorrect = responseData.count.correct
				this.countIncorrect = responseData.count.incorrect

				this.applicationEarnPoint = responseData.applicationEarnPoint
				this.solveAllEarnPoint = responseData.solveAllEarnPoint
				this.getTotalPoint = this.applicationEarnPoint + this.solveAllEarnPoint

				this.scoreMy = responseData.score
				this.examActions = responseData.actions

				this.questions = _.chain(responseData.groups)
					.map((item) => {
						return item.questions
					})
					.flatten()
					.map((question, index) => {
						return question
					}).value()

				// console.log('this.questions', this.questions);
				
			}).catch((err) => {
				
			})


			examApi.score(params).then((response) => {
				this.scoreData = response.data.data
				this.averageScore = parseInt(this.scoreData.averageScore)
				this.standard = parseInt(this.scoreData.standard)
				this.score = parseInt(this.scoreData.score)
				

			}).catch((err) => {
				
			})
			


			
			
			

		}).catch((err) => {
			
		})

		// examApi.examIntro(params).then((response) => {
		//     this.examData = response.data.data
		//     //console.log('examIntro', this.examData)
		//     //this.examActions = this.examData.actions

		// }).catch((err) => {
			
		// })
		
		this.setMaterialUi()
	},

	methods: {
		toggleQuestionViewStatus() {
			this.questionViewStatus = !this.questionViewStatus
		},

		setButtonActionName(action) {
			//before_start : ~부터 응시가능
			//can_start : 응시
			//can_re_start : 재응시
			//before_confirm : ~부터 결과확인 가능
			//open_confirm : 결과확인
			let buttonName = ''
			if (action.action === 'before_start') {
				buttonName = this.$t('50010', {str: $moment(action.data.application_start_time).format('L')})    // action.data.application_start_time + '부터 응시가능'
			}else if (action.action === 'can_start') {
				buttonName = this.$t('50008')   //'응시'
			}else if (action.action === 'can_re_start') {
				buttonName = this.$t('86') // '재응시'
			}else if (action.action === 'before_confirm') {
				buttonName = this.$t('50011', {str: $moment(action.data.confirm_start_time).format('L')}) //action.data.confirm_start_time + '~부터 결과확인 가능'
			}else if (action.action === 'open_confirm') {
				buttonName =  this.$t('85') //'결과확인'
			}
			return buttonName
		},

		setButtonDisabled(action) {
			return action.action === 'before_start' || action.action === 'before_confirm' ? true : false
		},

		examAction(action) {
			if (action.action === 'can_start') {
				this.startExam()
			}else if (action.action === 'can_re_start') { 
				this.$router.push({
					name: 'IndependentExamIntro', 
					query: this.$route.query
				})
			}else if (action.action === 'open_confirm') {
				//this.startExam()
				//console.log('결과보기로 ㄱㄱ');
				this.moveExamFeedback()
				
			}
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		
	}
}
</script>

<style scoped>

 
  .total-percentage{
	  background-color: rgba(172, 180, 190, 0.3);
  }
  .opacity7{
	  opacity: 0.7;
  }
  .total-percentage .real-percentage{
	  position: absolute;
	  left: 0;
	  top:-3px;
	  border-radius:6px;
	  width: 237px;
  }
  html[dir="rtl"] .total-percentage .real-percentage{
	  right: 0;
  }
  .standard-percentage{
	  color: var(--Iconinactive);
  }
  .standard-percentage:after {
	content: '';
	position: absolute;
	width: 0;
	height: 68px;
	border: dashed var(--Divider);
	border-width: 0.2px;
	bottom: 20px;
	left: 50%;
  }
	html[dir="rtl"] .standard-percentage:after {
	right: 50%;
  }
  .standard-percentage-wrap{position: relative;width: 100%;padding-bottom: 20px;}
  .standard-percentage-wrap .standard-percentage{
		left: 0%; 
		width:90px;
		position: absolute !important;
	}
	html[dir="rtl"] .standard-percentage-wrap .standard-percentage{
		right: 0%; 
	}
	.dotted-line{
		content: '';
		position: absolute;
		width: 0;
		height: 68px;
		border: dashed var(--Divider);
		border-width: 0.2px;
		bottom: 20px;
		left: 50%;
	}
	html[dir="rtl"] .dotted-line{
		right: 50%;
	}

	.exam-view-detail .question-correct {
	background: none;
  
	top: 50%;
	left: 50%;
 
	width: 24px;
	height: 24px;
	border: 3px solid #76a0d6;
	border-radius: 54px;
	transform: translate(-50%,-50%);
	}
	html[dir="rtl"] 	.exam-view-detail .question-correct {
	right: 50%;
	}

	.exam-view-detail .question-incorrect{
		background: none;
  
	top: 50%;
	left: 50%;
 border: none;
	width: 24px;
	height: 24px;
   border-radius: 0px;
	transform: translate(-50%,-50%);
	
	}
	html[dir="rtl"] .exam-view-detail .question-incorrect{
	right: 50%;
	}
   .exam-view-detail .question-incorrect:after {
	content: '';
	height: 24px;
	border-left: 2px solid #f16d70;
	position: absolute;
	transform: rotate(45deg);
   
}
html[dir="rtl"] .exam-view-detail .question-incorrect:after {
	border-right: 2px solid #f16d70;
}

.exam-view-detail .question-incorrect:before {
	content: '';
	height: 24px;
	border-left: 2px solid #f16d70;
	position: absolute;
	transform: rotate(-45deg);
	
}
html[dir="rtl"] .exam-view-detail .question-incorrect:before {
	border-right: 2px solid #f16d70;
}
  
</style>